__turbopack_context__.v({
  "absolute": "auction_item-module-scss-module__7SY9lq__absolute",
  "brand": "auction_item-module-scss-module__7SY9lq__brand",
  "imageHover": "auction_item-module-scss-module__7SY9lq__imageHover",
  "listCardTwoColumn": "auction_item-module-scss-module__7SY9lq__listCardTwoColumn",
  "listingCard": "auction_item-module-scss-module__7SY9lq__listingCard",
  "listingCardAuction": "auction_item-module-scss-module__7SY9lq__listingCardAuction",
  "listingCardImg": "auction_item-module-scss-module__7SY9lq__listingCardImg",
  "name": "auction_item-module-scss-module__7SY9lq__name",
  "overlay": "auction_item-module-scss-module__7SY9lq__overlay",
  "priceBox": "auction_item-module-scss-module__7SY9lq__priceBox",
  "priceInfoDesktop": "auction_item-module-scss-module__7SY9lq__priceInfoDesktop",
  "priceInfoMobile": "auction_item-module-scss-module__7SY9lq__priceInfoMobile",
  "proAuction": "auction_item-module-scss-module__7SY9lq__proAuction",
  "productImage": "auction_item-module-scss-module__7SY9lq__productImage",
  "saleTime": "auction_item-module-scss-module__7SY9lq__saleTime",
  "variants": "auction_item-module-scss-module__7SY9lq__variants",
});
